import './Amount.scss';

const init = () => {
    let amountElement = document.getElementById('js-donation-amount');
    if(amountElement) {
        let httpRequest = new XMLHttpRequest();
        httpRequest.open('GET', '/donations.json', true);
        httpRequest.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    let json = window.JSON ? JSON.parse(this.responseText) : eval('(' + this.responseText + ')');
                    let amountString = (json.summe.toFixed(0) + ',').replace(/\d(?=(\d{3})+,)/g, '$&.').slice(0, -1);
                    amountElement.innerHTML = amountString;
                } else console.error('HTTP error ' + this.status + ' ' + this.statusText);
            }
        };
        httpRequest.send();
    }
};

init();

